module.exports = __webpack_public_path__ + "img/hr-rock-huge-16.c0bfe12b.png";